/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import {ValidatorFn, Validators} from "@angular/forms";

export interface TaskUser { 
    readonly id: number;
    name: string;
    email: string;
    readonly isTherapist: boolean;
    readonly isPatientops: boolean;
}
export const TaskUser_id_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TaskUser_name_Validators: ValidatorFn[] =
    [  Validators.required,  Validators.maxLength(255),];

export const TaskUser_email_Validators: ValidatorFn[] =
    [  Validators.required,  Validators.maxLength(254), Validators.email,];

export const TaskUser_isTherapist_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TaskUser_isPatientops_Validators: ValidatorFn[] =
    [  Validators.required, ];


